import React, { useEffect, useState, useCallback } from "react";
import PropTypes from "prop-types";
import { Grid } from "@mui/material";
import { useSelections } from "../../context/Selections";
import LayoutWrapper from "../../components/LayoutWrapper/LayoutWrapper";
import PDVSComPotencial from "../BaseCovarage/components/PDVSComPotencial";
import InsercaoLojas from "../BaseCovarage/components/InsercaoLojas";
import RankingSegmento from "../BaseCovarage/components/RankingSegmento";
import RankingCidade from "../BaseCovarage/components/RankingCidade";
import RankingUF from "../BaseCovarage/components/RankingUF";
import { Footer } from "../../components/Footer/Footer";
import { OverviewCardSkeleton } from "../../components/Cards";
import { useOverviewData } from "../../hooks";

function SellOutNiveaDesktop({
  app,
  pdvTitle,
  pdvObjectId,
  resultadosObjectId,
  rankingSegmentoObjectId,
  rankingUFObjectId,
  rankingCidadeObjectId,
}) {
  const { selections } = useSelections();
  const [nameUser, setNameUser] = useState("");
  const { isLoading } = useOverviewData(app);

  const getNameUser = useCallback(async () => {}, []);

  useEffect(() => {
    if (app) {
      getNameUser();
    }
  }, [app, getNameUser, selections]);

  const DEFAULT_IDS = {
    pdv: "3fca1a0f-9876-4e56-a178-1f0924225beb",
    resultados: "PfyNPf",
    segmento: "1d6bf131-5536-4b0b-a9cd-fafc80d58335",
    uf: "9cef0cf0-f069-4d64-9c45-374b30214a7b",
    cidade: "2f947f65-5df2-4903-b250-6f105242341b",
  };

  return (
    <div className="app overview">
      <div className="appContent">
        <LayoutWrapper>
          <Grid container flexDirection="column" justifyContent="flex-start" rowGap={2}>
            {isLoading ? (
              <Grid container spacing={2}>
                <Grid item xs={12} md={7}>
                  <OverviewCardSkeleton variant="rectangular" />
                </Grid>
                <Grid item xs={12} md={5}>
                  <OverviewCardSkeleton variant="rectangular" />
                </Grid>
                <Grid item xs={12} md={6} xl={3}>
                  <OverviewCardSkeleton variant="rectangular" />
                </Grid>
                <Grid item xs={12} md={6} xl={3}>
                  <OverviewCardSkeleton variant="rectangular" />
                </Grid>
                <Grid item xs={12} md={6} xl={3}>
                  <OverviewCardSkeleton variant="rectangular" />
                </Grid>
                <Grid item xs={12} md={6} xl={3}>
                  <OverviewCardSkeleton variant="rectangular" />
                </Grid>
              </Grid>
            ) : (
              <Grid item spacing={2} sx={{ marginBottom: "20px" }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={7} className="container-tables-tops">
                    <PDVSComPotencial
                      app={app}
                      title={pdvTitle}
                      objectId={pdvObjectId || DEFAULT_IDS.pdv}
                    />
                  </Grid>
                  <Grid item xs={12} md={5} className="container-tables-tops">
                    <InsercaoLojas
                      app={app}
                      title="Resultados"
                      objectId={resultadosObjectId || DEFAULT_IDS.resultados}
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid item spacing={2} xs={12} md={4} xl={4} className="container-tables-tops">
                    <RankingSegmento
                      app={app}
                      objectId={rankingSegmentoObjectId || DEFAULT_IDS.segmento}
                    />
                  </Grid>
                  <Grid item spacing={2} xs={12} md={4} xl={4} className="container-tables-tops">
                    <RankingUF
                      app={app}
                      objectId={rankingUFObjectId || DEFAULT_IDS.uf}
                    />
                  </Grid>
                  <Grid item spacing={2} xs={12} md={4} xl={4} className="container-tables-tops">
                    <RankingCidade
                      app={app}
                      objectId={rankingCidadeObjectId || DEFAULT_IDS.cidade}
                    />
                  </Grid>
                </Grid>
                <Grid item spacing={2}>
                  <Footer app={app} />
                </Grid>
              </Grid>
            )}
          </Grid>
        </LayoutWrapper>
      </div>
    </div>
  );
}

SellOutNiveaDesktop.propTypes = {
  app: PropTypes.object,
  pdvTitle: PropTypes.string,
  pdvObjectId: PropTypes.string,
  resultadosObjectId: PropTypes.string,
  rankingSegmentoObjectId: PropTypes.string,
  rankingUFObjectId: PropTypes.string,
  rankingCidadeObjectId: PropTypes.string,
};

export default SellOutNiveaDesktop;
